import { Box, createStyles, Skeleton, Stack } from '@mantine/core';
import { ParagraphSkeleton } from '@repo/foundations';

const useStyles = createStyles((theme) => ({
	userMessageContainer: {
		display: 'flex',
		alignSelf: 'flex-end',
		width: '50%',
	},
	userMessageContent: {
		backgroundColor: theme.other.getColor('fill/secondary/default'),
		borderRadius: theme.radius.md,
		padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
	},
	userToolbar: {
		alignSelf: 'flex-end',
	},
}));

export function MessageGroupSkeleton() {
	const { classes } = useStyles();

	return (
		<Stack spacing="xl">
			<Stack spacing={0} className={classes.userMessageContainer}>
				<Box className={classes.userMessageContent}>
					<Skeleton height={20} radius="md" />
				</Box>
			</Stack>
			<ParagraphSkeleton lines={3} />
		</Stack>
	);
}
